/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs */

const en_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Forced Narrative Subtitles`)
};

const fr_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer les sous-titres narratifs forces`)
};

const de_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzwungene narrative Untertitel ein-/ausschalten`)
};

const it_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva i sottotitoli narrativi forzati`)
};

const ru_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить/выключить принудительные субтитлы с повествованием`)
};

const es_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar subtítulos narrativos forzados`)
};

const zh_cn2_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换强制叙述字幕`)
};

const ja_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強制字幕のオン/オフ`)
};

const hi_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनिवार्य कथात्मक उपशीर्षक चालू/बंद करें`)
};

const pt_pt2_shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar/Desativar legendas narrativas forçadas`)
};

/**
* | output |
* | --- |
* | "Toggle Forced Narrative Subtitles" |
*
* @param {Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
	if (locale === "de") return de_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
	if (locale === "it") return it_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
	if (locale === "es") return es_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
	return en_shortcut_keys_name_toggle_forced_narrative_subtitles(inputs)
});